import React from "react"
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component"
import "react-vertical-timeline-component/style.min.css"
import {
  FaLaptopCode,
  FaUserGraduate,
  FaBookReader,
  FaAward,
} from "react-icons/fa"
import { AiOutlineStar } from "react-icons/ai"

import Title from "./Title"

export default () => {
  return (
    <div className="timeline">
      <section className="section-center">
        <Title title="My Story" />
        <div className="section-center">
          <VerticalTimeline>
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{ background: "rgb(16, 204, 82)", color: "#000" }}
              contentArrowStyle={{
                borderRight: "7px solid  rgb(16, 204, 82)",
              }}
              date="July 2019 - present"
              iconStyle={{ background: "rgb(16, 204, 82)", color: "#fff" }}
              icon={<FaLaptopCode />}
            >
              <h3 className="hero-detail">
                Software Engineer
              </h3>
              <h4 className="hero-detail">UKG Ultimate Kronos Group (Formerly Known as Kronos Inc)</h4>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              date="June 2019"
              iconStyle={{ background:"rgb(233, 30, 99)", color: "#fff" }}
              icon={<FaUserGraduate/>}
            >
              <h3 className="hero-detail">Graduated</h3>
              <h4 className="hero-detail">
                NIT Allahbad
              </h4>
              <p>Academic Score - 8.70/10</p>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              date="March 2019"
              iconStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
              icon={<FaAward />}
            >
              <h3 className="hero-detail">Flipkart GRiD Challenge</h3>

              <p>
                Qualified for Level 3, 5th within campus in Level 1 Qualifier{" "}
              </p>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              date="2018"
              iconStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
              icon={<FaAward />}
            >
              <h3 className="hero-detail">Hack36</h3>
              <h4 className="hero-detail">All India Hacking Competition</h4>
              <p>
                Secured <b>5th</b> position
              </p>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              date="August 2017"
              iconStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
              icon={<FaAward />}
            >
              <h3 className="hero-detail">DroidRush - CyberQuest</h3>
              <h4 className="hero-detail">{`Avishkar - MNNIT Allahbad`}</h4>
              <p>
                Amongst <b>Top 10 finalist</b>
              </p>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              date="December 2016"
              iconStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
              icon={<FaAward />}
            >
              <h3 className="hero-detail">Netcamp Winter Training</h3>
              <h4 className="hero-detail">
                {`Networking & Java Training Bootcamp - MNNIT Allahbad`}
              </h4>
              <p>
                Secured <b>1st</b> Position in Netcamp Winter Training
                Examination{" "}
              </p>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              className="vertical-timeline-element--education"
              date="June 2015"
              iconStyle={{ background: "rgb(16, 204, 82)", color: "#fff" }}
              icon={<FaUserGraduate />}
            >
              <h3 className="hero-detail">MNNIT Allahbad ( NIT-A )</h3>
              <h4 className="hero-detail">Bachelor Of Technology</h4>
              <p>Started Studying</p>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              className="vertical-timeline-element--education"
              date="2014"
              iconStyle={{ background: "rgb(233, 30, 99)", color: "#fff" }}
              icon={<FaBookReader />}
            >
              <h3 className="hero-detail">St. Mary's School</h3>
              <h4 className="hero-detail">
                Class XII ISC Board Examination - 91.60%
              </h4>
              <p>
                Secured <b>6th</b> position in <b>Mirzapur district</b> for
                academic excellence{" "}
              </p>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              className="vertical-timeline-element--education"
              date="2012"
              iconStyle={{ background: "rgb(233, 30, 99)", color: "#fff" }}
              icon={<FaBookReader />}
            >
              <h3 className="hero-detail">St. Mary's School</h3>
              <h4 className="hero-detail">
                Class X ICSE Board Examination - 91.43%
              </h4>
              <p>
                Attained <b>4th</b> position in <b>Mirzapur district</b> for
                academic excellence
              </p>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              iconStyle={{ background: "rgb(16, 204, 82)", color: "#fff" }}
              icon={<AiOutlineStar />}
            />
          </VerticalTimeline>
        </div>
      </section>
    </div>
  )
}
